<template>
  <form v-loading="loading && !model" @submit.prevent="submit()">
    <!-- Header -->
    <div v-if="!embeded" class="tournament-light-blue pa-3">
      <!-- Top -->
      <div class="row">
        <div class="row align-center flex">
          <v-btn class="ma-0" icon @click="$emit('close')">
            <v-icon color="tournament-white">
arrow_back
</v-icon>
          </v-btn>
        </div>
        <v-btn
          v-if="model"
          :loading="loading"
          type="submit"
          class="ma-0 rounded"
          color="tournament-white tournament-green--text"
        >
          Salvar
        </v-btn>
      </div>

      <div v-if="model" class="row flex px-2 mt-3">
        <v-text-field
          v-model="model.name"
          v-validate="'required|min:2'"
          class="big-title tournament-white--text"
          color="tournament-white"
          label="Nome da equipe"
          type="text"
          data-vv-name="team.name"
          data-vv-as="nome da equipe"
          :error-messages="errors.collect('team.name')"
        />
      </div>
    </div>

    <!-- Form -->
    <div
      v-loading="loading"
      class="tournament-white px-4 pt-3 pb-5"
      style="min-height: 300px"
      element-loading-text="Carregando dados da equipes"
    >
      <v-text-field
        v-if="embeded"
        v-model="model.name"
        v-validate="'required|min:2'"
        class="big-title"
        color="tournament-white"
        label="Nome da equipe"
        type="text"
        :class="getInputClass"
        :disabled="!isEditable"
        data-vv-name="team.name"
        data-vv-as="nome da equipe"
        :error-messages="errors.collect('team.name')"
      />

      <div v-if="model.about" class="about">
        <v-select
          v-model="model.about.origin"
          color="tournament-black"
          class="tournament-black--text"
          :prepend-icon="$vuetify.breakpoint.xsOnly ? '' : 'account_balance'"
          label="Origem da equipe"
          :class="!isEditable ? 'translucid' : ''"
          :disabled="!isEditable"
          :items="possibleOrigins"
          item-text="label"
          item-value="_id"
        />

        <!-- Year of foundation -->
        <v-select
          v-model="model.about.foundationYear"
          color="tournament-black"
          class="tournament-black--text"
          :class="getInputClass"
          :disabled="!isEditable"
          :items="possibleYearsFoundation"
          label="Ano de fundação da equipe"
        />
      </div>

      <div v-if="model.social" class="links mt-5">
        <!-- Facebook -->
        <v-text-field
          v-model="model.social.facebook"
          color="tournament-black"
          class="tournament-black--text"
          :prepend-icon="$vuetify.breakpoint.xsOnly ? '' : 'language'"
          label="Facebook da equipe"
          :class="!isEditable ? 'translucid' : ''"
          :disabled="!isEditable"
        />

        <!-- Site -->
        <v-text-field
          v-model="model.social.website"
          color="tournament-black"
          class="tournament-black--text"
          label="Site da equipe"
          :class="getInputClass"
          :disabled="!isEditable"
        />
      </div>

      <div
        v-if="model.contact && community !== 'fll-open-brazil'"
        class="school mt-5"
      >
        <!-- School name -->
        <v-text-field
          v-model="model.contact.name"
          v-validate="'required|min:2'"
          color="tournament-black"
          class="tournament-black--text"
          :prepend-icon="$vuetify.breakpoint.xsOnly ? '' : 'school'"
          label="Nome da escola"
          :class="!isEditable ? 'translucid' : ''"
          :disabled="!isEditable"
          data-vv-name="contact.name"
          data-vv-as="nome da escola"
          :error-messages="errors.collect('contact.name')"
        />

        <!-- School phone -->
        <v-text-field
          v-model="model.contact.phone"
          v-validate="'required'"
          v-mask="['(##) ####-####', '(##) #####-####']"
          color="tournament-black"
          class="tournament-black--text"
          label="Telefone da escola"
          :class="getInputClass"
          :disabled="!isEditable"
          data-vv-name="contact.phone"
          data-vv-as="telefone da escola"
          :error-messages="errors.collect('contact.phone')"
        />

        <AddressForm
          v-if="model.contact.address"
          v-model="model.contact.address"
          :class="getInputClass"
          :editing="isEditable"
        />
      </div>
    </div>
  </form>
</template>

<script>
import _ from "lodash";
import AddressForm from "@/components/AddressForm";
import Error from "@/components/Error";
import Team from "@/services/Team";

import ParseHTTPError from "@/helpers/ParseHTTPError";
export default {
  name: "TeamEditor",

  components: {
    AddressForm,
    Error,
  },

  props: {
    cache: {
      type: Object,
    },
    modelId: {
      type: String,
    },
    embeded: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      model: {},

      possibleOrigins: [
        { label: "Escola pública", _id: "public" },
        { label: "Escola privada", _id: "private" },
        { label: "Equipe de garagem", _id: "garage" },
        { label: "Escola SESI", _id: "sesi" },
        { label: "ONG", _id: "ong" },
      ],

      community: "fll-brasil",
    };
  },

  computed: {
    defaults() {
      return {
        social: {},
        contact: {
          address: {},
        },
        about: {},
      };
    },

    isEditable() {
      return this.editable;
    },

    isNew() {
      return !this.modelId;
    },

    getInputClass() {
      let classes = "";

      if (!this.isEditable) {
        classes += "translucid ";
      }

      if (!this.$vuetify.breakpoint.xsOnly) {
        classes += "ml-4";
      }

      return classes;
    },

    possibleYearsFoundation() {
      // Returns all years since 2004 (year of foundation FLL in Brazil)
      const years = [];
      const currentYear = new Date().getFullYear() || 2018;
      for (let year = 1980; year <= currentYear; year++) {
        years.push(String(year));
      }
      return years.reverse();
    },
  },

  created() {
    // Set current model to show model faster (Cache version)
    if (this.cache && this.modelId == this.cache._id) {
      this.model = this.cache;
    }

    // Set Community
    this.community = window.LayersPortal.communityId;

    // Fetch model events and data
    if (this.modelId) {
      this.fetch();
    } else {
      // Creation mode
      this.model = this.defaults;
    }
  },

  methods: {
    fetch() {
      this.loading = true;

      Team.get(this.modelId).then(
        (model) => {
          this.loading = false;
          this.model = _.defaultsDeep(model.data, this.defaults);
        },
        () => {
          this.loading = false;
          this.$notify.error({
            title: "Erro",
            message: "Tente novamente",
          });
          this.$emit("close");
        },
      );
    },

    submit() {
      this.$validator.validateAll().then((result) => {
        // If throw errors in form, return
        if (!result) {
          this.$notify.error({
            title: "Encontramos alguns erros",
            message: this.$createElement("Error", {
              props: {
                error: this.errors,
              },
            }),
          });
          return;
        }
        this.save();
      });
    },

    save() {
      this.loading = true;

      // Depending if its creating or updating, select method to use
      const method = this.isNew ? "create" : "update";

      Team[method](this.model, this.modelId).then(
        (model) => {
          this.loading = false;
          // Emit created event
          this.$emit("answer", model.data);

          // Reset state (set model if was creating)
          if (this.isNew) {
            this.model = this.defaults;
          }

          // Show sucess message
          this.$notify.success({
            title: "Equipe salva",
            message: "Sua equipe foi salva com sucesso",
          });
        },
        (err) => {
          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
          this.loading = false;
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Teams/Editor/index.vue